import React from "react";
import classes from "./ModalInfo.module.css";
import { useTranslation } from "react-i18next";
import SmallLoader from "./Loaders/SmallLoader";

const ModalInfo = ({ setModal, unsubscribeUser, unsubLoading }) => {
    const { t } = useTranslation();

    return (
        <div className={classes.container} onClick={() => setModal(false)}>
            <div className={classes.sub_container} onClick={(e) => e.stopPropagation()}>
                <div className={classes.info}>
                    <img
                        src="/assets/images/warning.png"
                        alt="warning"
                        className={classes.img}
                    />
                </div>
                <div className={classes.msg}>
                    <p className={classes.text}>{t("83")}
                    </p>
                </div>
                <div className={classes.btns_container}>
                    <button className={classes.btn} type="button" disabled={unsubLoading} onClick={() => unsubscribeUser()}>
                        {unsubLoading ? <SmallLoader /> : t("80")}
                    </button>
                    <button
                        className={classes.btn_2}
                        type="button"
                        disabled={unsubLoading}
                        onClick={() => setModal(false)}
                    >
                        {t("81")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalInfo;